import { render } from "./QualityTransfer.vue?vue&type=template&id=5fd9bd00&scoped=true"
import script from "./QualityTransfer.vue?vue&type=script&lang=js"
export * from "./QualityTransfer.vue?vue&type=script&lang=js"

import "./QualityTransfer.vue?vue&type=style&index=0&id=5fd9bd00&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd9bd00"]])

export default __exports__